class QuickExit {
  constructor() {
    this.init();
  }

  init() {
    this.bindListeners();
  }

  bindListeners() {
    const _this = this;

    document
      .querySelector('body')
      ._addCustomEventListener('click', '.wb-sensitive-content__btn', _this.exitSite);
  }

  exitSite() {
    window.open('http://meteomedia.com', '_newtab');
    window.location.replace('https://google.com');
  }
}

document.addEventListener('readystatechange', (event) => {
  if (document.readyState == 'complete') {
    window.QuickExit = new QuickExit();
  }
});
